import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import apiAgent from "../../../app/api/apiAgent";
//import LoadingComponent from "../../../app/layout/LoadingComponent";
import { ClearCacheResponseModel } from "../../../app/models/ClearCacheResponseModel";
import { useStore } from "../../../app/stores/store";
import HeaderWrapper from "../../header/HeaderWrapper";
import ClearCacheBox from "./ClearCacheBox";
import AjaxLoader from "../../../app/common/common-components/AjaxLoader";
import Breadcrumb from "../../../app/common/common-components/Breadcrumb";

export default observer(function ClearCachePage() {
  const [isLoading, setIsLoading] = useState(true);
  const [clearCache, setClearCache] = useState<ClearCacheResponseModel>();
  const {
    userStore: { userSession, logout, isLoggedIn },
  } = useStore();

  useEffect(() => {
    setIsLoading(true);
    apiAgent.Admin.getClearCache()
      .then((response: ClearCacheResponseModel) => {
        let oClearCache: ClearCacheResponseModel = response;
        setClearCache(oClearCache);
        //console.log("clear Cache", oClearCache);
      })
      .catch((error: any) => {
        console.log(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  document.title = "Base - Clear Cache";

  if (isLoading) {
    return <AjaxLoader />;
  } else if (!isLoading && clearCache) {
    return (
      <>
        <div className="clearCache-page container-fluid">
          <Breadcrumb breadcrumbs={[{ text: "Home", path: "/" }, { text: "Settings", path: "/settings" }, { text: "Clear Cache" }]} />

          <div className="row">
            <div className="hidden-sm col-md-2"></div>
            <div id="content" className="col-sm-12 col-md-8">
              <ClearCacheBox cacheDD={clearCache.cacheDD} officeDD={clearCache.officeDD} />
            </div>
            <div className="hidden-sm col-md-2"></div>
          </div>
        </div>
      </>
    );
  } else {
    return <></>;
  }
});
